// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import queryString from 'query-string';
import CreateReport from './CreateReport';
import BobPage from '../../../components/BobPage';
import ReportTableContainer from './ReportTableContainer';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import * as DashboardActions from '../../../actions/dashboardActions';
import { setPageTitle } from '../../../helpers/auth';
import { isEmpty } from 'lodash';
import classes from './ReportPage.module.css';

const ReportPage = ({
    activeNavCompany,
    history,
    ...props
}) => {

    const [createMode, setCreateMode] = useState(false);
    const [selectedReport, setselectedReport] = useState(null);
    const [reportName, setReportName] = useState('New Report');
    const queryValues = queryString.parse(history.location.search);
    const [selectedView, setSelectedView] = useState('Inspection Reports');

    const handleBackClick = (selectedView) => {
        setCreateMode(false);
        setselectedReport(null);
        if (!isEmpty(selectedView)) {
            setSelectedView(selectedView);
        }
        else {
            setSelectedView('Inspection Reports');
        }

        // type field is not required in reports grid
        const { pathname } = history.location;
        if (queryValues.type) {
            delete queryValues.type;
            const queryValuesString = queryString.stringify(queryValues);
            history.push(`${pathname}?${queryValuesString}`);
        }
    };

    useEffect(() => {
        const { pathname } = history.location;
        if (!queryValues.company) {
            queryValues.company = activeNavCompany ? activeNavCompany.id : sessionStorage.getItem('companyId');
            const queryValuesString = queryString.stringify(queryValues);
            history.push(`${pathname}?${queryValuesString}`);
        }
    }, []);

    useEffect(() => {
        if (!isEmpty(activeNavCompany)) {
            if (createMode) {
                setPageTitle(`${activeNavCompany.name}`, 'New Report');
                setReportName('New Report');
            } else {
                setPageTitle(`${activeNavCompany.name}`, 'Reporting');
            }
        }
    }, [activeNavCompany, createMode]);

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    {
                        selectedReport || createMode ?
                            <span>
                                <span
                                    className={classes.BackIcon}
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() =>
                                        handleBackClick()
                                    }
                                >
                                    <i className="fas fa-chevron-left" />
                                </span>
                                {createMode ? `${reportName}` : `${selectedReport.title}`}
                            </span> : 'Reporting'
                    }
                </div>

                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    {
                        selectedReport || createMode ?
                            <CreateReport
                                handleBackClick={handleBackClick}
                                selectedReport={selectedReport}
                                setReportName={setReportName}
                            />
                            :
                            <ReportTableContainer
                                handleBackClick={handleBackClick}
                                createMode={createMode}
                                selectedView={selectedView}
                                setCreateMode={setCreateMode}
                                setSelectedAnnouncement={setselectedReport}
                                setSelectedView={setSelectedView}
                            />

                    }

                </div>
            </div>
        </BobPage>
    );
};

ReportPage.defaultProps = {
};

ReportPage.propTypes = {
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
    };
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportPage));
